(function() {
    'use strict';

    function View() {
        this.$cardsElem = $('.card-list__item');
        this.timeoutHide = 200;
        this.timeoutShow = 250;
    }

    View.prototype.formatCardDefault = function(cardData) {
        var html =
            '<a href="' +
            cardData.link +
            '" class="card-list__item card-list__item--default card-list__item--animation-show">' +
            '<div class="card-logo" style="background-color:' +
            cardData.color +
            '">' +
            '<img src="' +
            cardData.logo +
            '">' +
            '</div>' +
            '<div class="card-content">' +
            '<h5>' +
            cardData.title +
            '</h5>' +
            '<p>' +
            cardData.description +
            '</p>' +
            '<div class="card-content__cat caps">' +
            cardData.category +
            '</div></div></a>';

        return html;
    };

    View.prototype.formatCardNew = function(cardData) {
        var html =
            '<a href="' +
            cardData.link +
            '" class="card-list__item card-list__item--new card-list__item--animation-show">' +
            '<div class="card-img">' +
            '<img src="' +
            cardData.image +
            '">' +
            '</div><div class="card-content">' +
            '<div class="card-content__logo"' +
            'style="background-image: url(' +
            cardData.logo +
            ');' +
            'height:' +
            cardData.logoHeight +
            'px;">' +
            '</div>' +
            '<div class="card-content__img card-content__img--mobile">' +
            '<img src="' +
            cardData.image +
            '">' +
            '</div><p>' +
            cardData.description +
            '</p>' +
            '<div class="card-content__cat caps">' +
            cardData.category +
            '</div>' +
            '</div></a>';

        return html;
    };

    View.prototype.formatCardApi = function(cardData) {
        var html =
            '<div class="card-list__item card-list__item--api card-list__item--animation-show">' +
            '<div class="card-content">' +
            '<h5>' +
            cardData.title +
            '</h5>' +
            '<div class="card-content__img card-content__img--mobile">' +
            '<img src="' +
            cardData.image +
            '">' +
            '</div><p>' +
            cardData.description +
            '</p>' +
            '<a class="wg-btn wg-btn--hollow wg-btn--arrow card-content__link"' +
            'href="' +
            cardData.link +
            '">' +
            cardData.text +
            '<i></i></a>' +
            '</div><div class="card-img">' +
            '<img src="' +
            cardData.image +
            '">' +
            '</div></div>';

        return html;
    };

    View.prototype.renderContent = function($wrap, cards) {
        var html = '';
        var cardData = {};

        cards.forEach(
            function(card) {
                if (card.class_view === 'card-list__item--default') {
                    cardData = {
                        link: card.card_link,
                        color: card.color,
                        logo: card.logo,
                        title: card.title,
                        description: card.description,
                        category: card.category
                    };
                    html += this.formatCardDefault(cardData);
                } else if (card.class_view === 'card-list__item--new') {
                    cardData = {
                        link: card.card_link,
                        image: card.image,
                        logo: card.logo,
                        logoHeight: card.logo_height,
                        description: card.description,
                        category: card.category
                    };
                    html += this.formatCardNew(cardData);
                } else if (card.class_view === 'card-list__item--api') {
                    cardData = {
                        title: card.title,
                        description: card.description,
                        link: card.button_link,
                        text: card.button_text,
                        image: card.image
                    };
                    html += this.formatCardApi(cardData);
                }
            }.bind(this)
        );

        this.$cardsElem = $('.card-list__item');
        this.$cardsElem.addClass('card-list__item--animation-hide');

        setTimeout(function() {
            $wrap.html(html);
        }, this.timeoutHide);

        setTimeout(
            function() {
                this.$cardsElem = $('.card-list__item');
                this.$cardsElem.removeClass('card-list__item--animation-show');
            }.bind(this),
            this.timeoutShow
        );
    };

    window.apps = window.apps || {};
    window.apps.View = View;
})();



// WEBPACK FOOTER //
// ./assets/js/projects/apps/widgets/cards-view.js